module.exports = __webpack_public_path__ + "img/feedback2.099727d9.svg";